import { tokenRefs } from "../theme/tokens";

export const colorsConfig = {
  background: tokenRefs.surface.base,
  textPrimary: tokenRefs.surface.text,
  textSecondary: tokenRefs.surface.textSecondary,
  textTertiary: tokenRefs.colors.info[600],
  cardBg: tokenRefs.surface.sunken,
  iconPrimary: tokenRefs.colors.orange[300],
  iconSecondary: tokenRefs.colors.info[600],
  border: tokenRefs.surface.border,
};
